import { useI18n } from '../../../i18n';
import { ReactNode } from 'react';
import { cn } from '../../../utils/cn';

interface AlertBannerProps {
  icon?: ReactNode;
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  onDismiss?: () => void;
  variant?: 'warning' | 'error' | 'info';
  className?: string;
}

export function AlertBanner({
  icon,
  message,
  actionLabel = 'View details',
  onAction,
  onDismiss,
  variant = 'warning',
  className,
}: AlertBannerProps) {
  const { t } = useI18n();
  return (
    <div
      className={cn(
        'flex items-center justify-between rounded-[14px] border px-4 py-3',
        variant === 'warning' && 'border-[#FFF085] bg-[#FEFCE8]',
        variant === 'error' && 'border-red-200 bg-red-50',
        variant === 'info' && 'border-blue-200 bg-blue-50',
        className
      )}
    >
      <div className="flex items-center gap-3">
        {icon ?? (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className="shrink-0">
            <path
              d="M10 2L1.5 17h17L10 2zm0 3.5L16 16H4L10 5.5zM9 9v3h2V9H9zm0 4v2h2v-2H9z"
              fill="#D08700"
            />
          </svg>
        )}
        <p className="text-sm text-[#666666]">{message}</p>
      </div>
      <div className="flex shrink-0 items-center gap-3">
        {onAction && (
          <button
            onClick={onAction}
            className="text-sm font-medium text-[#0288D1] hover:underline"
          >
            {actionLabel}
          </button>
        )}
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="rounded p-1 text-[#666666] hover:bg-black/5"
            aria-label={t('dismiss')}
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M12 4L4 12M4 4l8 8"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
